module.exports = __webpack_public_path__ + "static/media/intro-video.da2dd5c7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/videos/intro-video.mp4
// module id = 473
// module chunks = 0